import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    fontSize: pxToRem(16),
    marginLeft: pxToRem(24),
    color: theme.palette.themePrimary,
  },
  first: {
    marginTop: pxToRem(5),
    verticalAlign: 'middle',
    selectors: {
      '&:hover': {
        color: theme.palette.themeDarkerAlt,
        background: 'none',
      },
      '&:focus': {
        color: theme.palette.themeDarker,
      },
    },
  },
  last: {
    marginTop: pxToRem(5),
    verticalAlign: 'middle',
    selectors: {
      '&:hover': {
        color: theme.palette.themeDarkerAlt,
        background: 'none',
      },
      '&:focus': {
        color: theme.palette.themeDarker,
      },
    },
  },
  previous: {
    marginTop: pxToRem(5),
    verticalAlign: 'middle',
    selectors: {
      '&:hover': {
        color: theme.palette.themeDarkerAlt,
        background: 'none',
      },
      '&:focus': {
        color: theme.palette.themeDarker,
      },
    },
  },
  next: {
    marginTop: pxToRem(5),
    verticalAlign: 'middle',
    selectors: {
      '&:hover': {
        color: theme.palette.themeDarkerAlt,
        background: 'none',
      },
      '&:focus': {
        color: theme.palette.themeDarker,
      },
    },
  },
  pageNumber: {
    width: pxToRem(70),
    height: pxToRem(32),
    borderRadius: pxToRem(2),
    borderColor: theme.palette.neutralTertiary,
    backgroundColor: theme.palette.neutralWhite,
    selectors: {
      '&:hover': {
        borderColor: theme.palette.neutralDarkAlt,
      },
      '&:focus': {
        borderColor: theme.palette.neutralDark,
      },
    },
  },
  totalPages: {
    width: 'fit-content',
    height: pxToRem(19),
    margin: `${pxToRem(10)} 0 ${pxToRem(7)} ${pxToRem(8)}`,
    fontSize: pxToRem(14),
  },
});
